import { z } from 'zod';

declare module 'zod' {
  interface ZodType<Output, Def extends z.ZodTypeDef, Input> {
    nullableDefault(): z.ZodEffects<
      z.ZodNullable<z.ZodType<Output, Def, Input>>,
      Output,
      Input | null
    >;
  }
}

// need to use function declaration to bind 'this'
// eslint-disable-next-line no-restricted-syntax
function nullableDefault<T extends z.ZodTypeAny>(this: T) {
  // .default() only works if the value is not null, so we need to transform the
  // value to undefined so the default value is applied
  return this.nullable().transform((v: unknown) =>
    v === null ? undefined : v,
  );
}

// Attach the method to Zod's prototype so it's available as a chainable method
z.ZodType.prototype.nullableDefault = nullableDefault;
